module.exports = __webpack_public_path__ + "images/emoji/minidisc.c51f6bbfecc3aeefadf0.png";